module.exports = __webpack_public_path__ + "static/img/service_cont_02_zh.806a0cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_cont_02_zh.png
// module id = N2wj
// module chunks = 34